import { Store } from "../../../@types/online-reservation.js";

export class SelectionState {
  public readonly selectedSize: string;
  public readonly selectedStore: Store;

  constructor(
    selectedSize = '',
    selectedStore: Store = { name: '', storeId: 0 }
  ) {
    this.selectedSize = selectedSize;
    this.selectedStore = selectedStore;
  }

  public selectSize(sizeId: string): SelectionState {
    return new SelectionState(sizeId, this.selectedStore);
  }

  public selectStore(store: Store): SelectionState {
    return new SelectionState(this.selectedSize, store);
  }

  public static reset(): SelectionState {
    return new SelectionState();
  }


  public saveSelectedStoreId(): void {
    if (this.selectedStore.storeId) {
      window.localStorage.setItem('ents:hvaHausNummer', `${this.selectedStore.storeId}`);
    }
  }
}
